import React, { useContext, useMemo } from "react";
import { ContentV2 } from "./Components";
import { ConfigurationContext } from "us.common/ConfigurationContext/ConfigurationProvider";
import "./NotesAndMessages.scss";

const NotesAndMessages: React.FC = () => {
  const context = useContext(ConfigurationContext);
  const notePermissions = useMemo(() => {
    return (
      context?.componentPermission &&
      context?.componentPermission["case"].components["messageAndNotes"]
        .components
    );
  }, [context?.componentPermission]);

  const getContent = () => {
    return <ContentV2 notePermissions={notePermissions} />;
  };
  return <>{getContent()}</>;
};

export default NotesAndMessages;
